export default "__VITE_ASSET__DrcV0wYR__"